module.exports = __webpack_public_path__ + "img/G_Art_Claw_R_1_3_5.96a5b4a5.png";